import Morpheme from './morpheme.js'

export default class Suffix extends Morpheme {
}
